interface CompaniesListProps {
  companies: string[];
}

export const CompaniesList = ({ companies }: CompaniesListProps) => (
  <div className='names'>
    {companies.map(company => (
      <p key={company}>{company}</p>
    ))}
  </div>
);
